var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 514.25 517.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.12,500.17c69.54-2.78,125.94-8.94,137.34-26.62-.13-16-.24-30.91-.37-46.91-66.26,27.65-223.29,27.87-273.93,0-.13,16-.24,30.91-.37,46.91,11.4,17.68,67.8,23.84,137.33,26.62Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.27,47.17q-4.59-17.28-9.17-34.56c-13-8.77-33.62-12.25-59-12.36-25.35.11-45.93,3.59-59,12.36Q193.58,29.89,189,47.17Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.17,463.05c-25.36-2.44-46.31,1.64-63.75,10.87L48.88,517c24.3,1.13,43.53-2.81,58.26-11.25l-8-42.74Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415.08,463.05c25.36-2.44,46.31,1.64,63.75,10.87L465.37,517c-24.3,1.13-43.53-2.81-58.26-11.25l8-42.74Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view-back") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.12,500.17c69.54-2.78,125.94-8.94,137.34-26.62-.13-16-.24-30.91-.37-46.91,5.82-8.7,11.82-20.83,11.77-31.22-.14-26.19-12.16-53.92-12.43-78.08,4.84-13.56,4.6-9.22,2.27-23.95-1.9-11.95-3.51-22.63-5.09-34.14,11.33-49.54,28.13-101.91,52.15-157.62-5.61-13.39-18-22.81-35.59-30.52-3.9-1.71-7.78-3.22-11.92-4.78C381.39,61.09,372.17,59,358,55.52c-10.68-2.59-20.6-5.38-32.69-8.35q-4.59-17.28-9.17-34.56c-13-8.77-33.62-12.25-59-12.36-25.35.11-45.93,3.59-59,12.36Q193.58,29.89,189,47.17c-12.09,3-22,5.76-32.69,8.35C142.08,59,132.86,61.09,119,66.33c-4.14,1.56-8,3.07-11.92,4.78-17.62,7.71-30,17.13-35.6,30.52,24,55.71,40.83,108.08,52.16,157.62-1.58,11.51-3.19,22.19-5.09,34.14-2.33,14.73-2.57,10.39,2.27,23.95-.27,24.16-12.3,51.89-12.43,78.08,0,10.39,6,22.52,11.77,31.22-.13,16-.24,30.91-.37,46.91,11.4,17.68,67.8,23.84,137.33,26.62Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.12,500.17c69.54-2.78,125.94-8.94,137.34-26.62-.13-16-.24-30.91-.37-46.91,5.82-8.7,11.82-20.83,11.77-31.22-.14-26.19-12.16-53.92-12.43-78.08,4.84-13.56,4.6-9.22,2.27-23.95-1.9-11.95-3.51-22.63-5.09-34.14,11.33-49.54,28.13-101.91,52.15-157.62-5.61-13.39-18-22.81-35.59-30.52-3.9-1.71-7.78-3.22-11.92-4.78C381.39,61.09,372.17,59,358,55.52c-10.68-2.59-20.6-5.38-32.69-8.35q-4.59-17.28-9.17-34.56c-13-8.77-33.62-12.25-59-12.36-25.35.11-45.93,3.59-59,12.36Q193.58,29.89,189,47.17c-12.09,3-22,5.76-32.69,8.35C142.08,59,132.86,61.09,119,66.33c-4.14,1.56-8,3.07-11.92,4.78-17.62,7.71-30,17.13-35.6,30.52,24,55.71,40.83,108.08,52.16,157.62-1.58,11.51-3.19,22.19-5.09,34.14-2.33,14.73-2.57,10.39,2.27,23.95-.27,24.16-12.3,51.89-12.43,78.08,0,10.39,6,22.52,11.77,31.22-.13,16-.24,30.91-.37,46.91,11.4,17.68,67.8,23.84,137.33,26.62Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.12,500.17c69.54-2.78,125.94-8.94,137.34-26.62-.13-16-.24-30.91-.37-46.91-66.26,27.65-223.29,27.87-273.93,0-.13,16-.24,30.91-.37,46.91,11.4,17.68,67.8,23.84,137.33,26.62Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.06,438.86l-.07,8.95c9.16,6.22,22.39,10.86,38.84,14.25a378.56,378.56,0,0,0,47.55,6.14,670.45,670.45,0,0,0,101.11,0,379.58,379.58,0,0,0,47.93-6.16c16.45-3.39,29.68-8,38.84-14.25l-.07-8.95-2,1.73c-8.3,6.36-21.38,11.09-38.18,14.55a372.13,372.13,0,0,1-46.9,6,662.27,662.27,0,0,1-100.49,0,370.65,370.65,0,0,1-46.36-6c-16.8-3.46-29.88-8.19-38.18-14.55l-2-1.73Zm86.32,36.46a369.2,369.2,0,0,1-46.13-6c-16.8-3.47-29.88-8.2-38.18-14.55L120,453l-.07,9c9.17,6.26,22.43,10.92,39,14.33a378.63,378.63,0,0,0,47.42,6.12,669.22,669.22,0,0,0,101.61,0,378.62,378.62,0,0,0,47.56-6.13c16.52-3.41,29.78-8.07,38.95-14.33l-.07-9-2.12,1.83c-8.3,6.35-21.38,11.08-38.18,14.55a369,369,0,0,1-46.52,6,662.53,662.53,0,0,1-101.1,0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M257.12,500.17c69.54-2.78,125.94-8.94,137.34-26.62-.13-16-.24-30.91-.37-46.91-66.26,27.65-223.29,27.87-273.93,0-.13,16-.24,30.91-.37,46.91,11.4,17.68,67.8,23.84,137.33,26.62Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.61,259.25c11.33-49.54,28.13-101.91,52.15-157.62,25.88,57,45.17,119.91,66.78,177.83,5.82,15.61.69,19.84,2.43,34.59A279.59,279.59,0,0,1,513.1,370c-.78,9.43-4.34,20.09-6.13,29.13a290.22,290.22,0,0,0-4.91,37.63c-.1,2.07-4.48,2.19-5.05,4.07-.78,2.55,3,7,1.94,9.5-5.33,12-14.52,15-20.12,23.61l-63.75-10.87c.63-11.21-2.21-24.94-1.23-35.68.61-6.65,5.27-12.31,5.86-24.37.07-1.22.13-2.45.18-3.68.69-14.67-.16-29.69.4-44.55.12-3.3,3.25-5.67,3.51-9,.23-2.84-3.62-5.66-3.71-8.61-.08-2.44,4.32-4.13,4.29-6.64-.05-3.21-5.1-1.77-5.4-3.76-.41-2.75,4.53-4.15,4.66-6.57-1.05-1.78-4.63-1.88-5.44-3.79-7.16-16.84-21.4-40.63-27.59-57.19Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.27,47.17q-4.59-17.28-9.17-34.56c-13-8.77-33.62-12.25-59-12.36-25.35.11-45.93,3.59-59,12.36Q193.58,29.89,189,47.17Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M323.27,39.65l-1.94-7.3q-6.72-.68-13.84-1.19a670.45,670.45,0,0,0-101.11,0c-4.61.35-9.1.73-13.46,1.17L191,39.65c5-.53,10.25-1,15.63-1.4a663.57,663.57,0,0,1,100.49,0c5.58.42,11,.89,16.17,1.44Zm-3.87-14.6-1.93-7.28c-3.14-.29-6.35-.55-9.61-.79a669.22,669.22,0,0,0-101.61,0c-3.22.24-6.37.5-9.47.78l-1.93,7.28q5.63-.54,11.53-1a662.53,662.53,0,0,1,101.1,0q6.11.45,11.92,1Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M325.27,47.17q-4.59-17.28-9.17-34.56c-13-8.77-33.62-12.25-59-12.36-25.35.11-45.93,3.59-59,12.36Q193.58,29.89,189,47.17Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.64,259.25c-11.33-49.54-28.13-101.91-52.16-157.62-25.87,57-45.16,119.91-66.77,177.83C-1.11,295.07,4,299.3,2.28,314.05A279.59,279.59,0,0,0,1.15,370c.78,9.43,4.34,20.09,6.13,29.13a290.22,290.22,0,0,1,4.91,37.63c.1,2.07,4.48,2.19,5,4.07.77,2.55-3,7-1.95,9.5,5.34,12,14.53,15,20.13,23.61l63.75-10.87c-.63-11.21,2.21-24.94,1.23-35.68-.61-6.65-5.27-12.31-5.86-24.37-.07-1.22-.13-2.45-.18-3.68-.69-14.67.16-29.69-.4-44.55-.12-3.3-3.25-5.67-3.51-9-.23-2.84,3.62-5.66,3.71-8.61.08-2.44-4.32-4.13-4.29-6.64,0-3.21,5.1-1.77,5.4-3.76.41-2.75-4.53-4.15-4.67-6.57,1.06-1.78,4.64-1.88,5.45-3.79,7.16-16.84,21.4-40.63,27.59-57.19Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.17,463.05c-25.36-2.44-46.31,1.64-63.75,10.87L48.88,517c24.3,1.13,43.53-2.81,58.26-11.25l-8-42.74Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.34,496.09l2.18,7,.7-.46A83,83,0,0,1,72,492.67a134.93,134.93,0,0,1,31.49-2l.81.07L103,483.57a141.29,141.29,0,0,0-32.29,2.16,90.25,90.25,0,0,0-28.36,10.36Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,485.42l2.18,7,.76-.49a82.14,82.14,0,0,1,27.26-10.49,134,134,0,0,1,32.19-2.14l.82.14-1.35-7.23a139.88,139.88,0,0,0-33,2.31A89.42,89.42,0,0,0,39,485.42Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.17,463.05c-25.36-2.44-46.31,1.64-63.75,10.87L48.88,517c24.3,1.13,43.53-2.81,58.26-11.25l-8-42.74Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.08,463.05c25.36-2.44,46.31,1.64,63.75,10.87L465.37,517c-24.3,1.13-43.53-2.81-58.26-11.25l8-42.74Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.91,496.09l-2.18,7-.7-.46a83,83,0,0,0-26.81-9.93,134.93,134.93,0,0,0-31.49-2l-.81.07,1.34-7.17a141.29,141.29,0,0,1,32.29,2.16,90.25,90.25,0,0,1,28.36,10.36Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.24,485.42l-2.18,7-.76-.49A82.14,82.14,0,0,0,445,481.41a134,134,0,0,0-32.19-2.14l-.82.14,1.35-7.23a139.88,139.88,0,0,1,33,2.31,89.42,89.42,0,0,1,28.82,10.93Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M415.08,463.05c25.36-2.44,46.31,1.64,63.75,10.87L465.37,517c-24.3,1.13-43.53-2.81-58.26-11.25l8-42.74Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewBack);
export default __webpack_public_path__ + "static/media/view-back.ef6ae5cca013b554159cb13ff94b255d.svg";
export { ForwardRef as ReactComponent };